import { render, staticRenderFns } from "./emergencyGroup.vue?vue&type=template&id=5ea99091&scoped=true&"
import script from "./emergencyGroup.vue?vue&type=script&lang=js&"
export * from "./emergencyGroup.vue?vue&type=script&lang=js&"
import style0 from "./emergencyGroup.vue?vue&type=style&index=0&id=5ea99091&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea99091",
  null
  
)

export default component.exports